import React from "react";
import IdentityPickerModal from "./IdentityPickerModal";

/**
 * CustomerPickerModal — organisation-only picker.
 *
 * Kept as a thin wrapper so existing call sites (the topbar org switcher) keep working
 * unchanged while the persona-aware flow rolls out. `groupByPersona={false}` reproduces
 * exactly the old single-step behaviour: one list of organisations, no persona step.
 *
 * New call sites should use IdentityPickerModal directly.
 */
const CustomerPickerModal = (props) => <IdentityPickerModal {...props} groupByPersona={false} />;

export default CustomerPickerModal;
